export default __webpack_public_path__ + "static/media/graphql-logo.ffcbb7ae.png";